import { Component, Input, OnInit } from '@angular/core';
import { StationService } from '@accounts/user/services/station.service';
import { GasStationModel } from '@core/api';
import { MapService } from '@accounts/user/services/map.service';
import { TariffService } from '@accounts/user/services/tariff.service';

@Component({
  selector: 'user-modal-station-list',
  templateUrl: './modal-station-list.component.html',
  styleUrls: ['./modal-station-list.component.scss']
})
export class ModalStationListComponent implements OnInit {

  @Input() small: boolean = false;

  constructor(
    public stationService: StationService,
    public tariffService: TariffService,
    private mapService: MapService
  ) {}

  get stationList(): Set<GasStationModel> {
    return this.mapService.stations;
  }

  getActive (station: GasStationModel) {
    return (this.stationService.station && (station.id === this.stationService.station.id));
  }

  select(station: GasStationModel) {
    this.stationService.getCurrentStationById(station.id)
      .subscribe(station => {
        this.tariffService.changeCurrentTariff(this.tariffService.customTariff.value);

        this.mapService.goToCurrentStation(
          station.coordinate_latitude,
          station.coordinate_longitude
        );
      });
  }

  closeCurrentStation() {
    this.stationService.reset();
  }

  ngOnInit() {
    if (this.stationService.station && this.stationService.station.id) {
      this.select(this.stationService.station);
    }
  }

}
